exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-9d600616] .v-btn-group--density-default.v-btn-group {\n  height: 32px !important;\n}\n", ""]);

// exports
